import React, { useEffect, useMemo, useState } from 'react'
import { ForecastDateRangePicker } from '../ForecastDateRangePicker'
import { useControlCenterOperationConfig } from '../../../hooks/useControlCenterOperationConfig'
import {
  TIME_RANGE_PRESET_OPTIONS,
  matchTimeRangePreset,
  resolveTimeRangePreset,
  type TimeRangePresetId,
} from '../../../utils/controlCenterOperationConfig'

type TimeRangeArgsFieldsProps = {
  startDate: string
  endDate: string
  onChange: (next: { timeStartDate: string; timeEndDate: string }) => void
}

/**
 * Quick-select preset + date range for the Time operator.
 */
export function TimeRangeArgsFields({ startDate, endDate, onChange }: TimeRangeArgsFieldsProps) {
  const { config } = useControlCenterOperationConfig()
  const inferred = useMemo(
    () => matchTimeRangePreset(startDate, endDate, config),
    [startDate, endDate, config],
  )
  const [preset, setPreset] = useState<TimeRangePresetId>(inferred)

  useEffect(() => {
    setPreset(inferred)
  }, [inferred])

  return (
    <div className="space-y-2">
      <label className="form-control w-full">
        <div className="label py-0 pb-1">
          <span className="label-text text-[11px]">Quick range</span>
        </div>
        <select
          className="select select-bordered select-sm w-full"
          value={preset}
          aria-label="Quick date range"
          onChange={(e) => {
            const next = e.target.value as TimeRangePresetId
            setPreset(next)
            if (next === 'custom') return
            const resolved = resolveTimeRangePreset(next, config)
            if (resolved) onChange(resolved)
          }}
        >
          {TIME_RANGE_PRESET_OPTIONS.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.label}
            </option>
          ))}
        </select>
      </label>
      <ForecastDateRangePicker
        startDate={startDate}
        endDate={endDate}
        onChange={({ startDate: s, endDate: e }) => {
          setPreset('custom')
          onChange({ timeStartDate: s, timeEndDate: e })
        }}
      />
    </div>
  )
}
